<template>
  <form @submit.prevent="handleRole" v-if="role" class="is-clearfix role-form">
    <h1 class="title is-3">{{ this.editMode ? 'Edit' : 'Create' }} role</h1>
    <div class="columns">
      <div class="column">
        <o-field label="Name" :type="fieldType('name')" :message="getError('name')">
          <template #label>
            Name <span style="color: red">*</span>
          </template>
          <o-input v-model="role.name"/>
        </o-field>

        <o-field label="Description" :type="fieldType('description')" :message="getError('description')">
          <template #label>
            Description <span style="color: red">*</span>
          </template>
          <o-input v-model="role.description"/>
        </o-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="columns toolbar-box">
          <o-field style="display: flex">
            <template #label>
              Role Permission
            </template>
            <o-tooltip label="select 3 essential permissions">
              <o-icon pack="mdi" icon="help-circle-outline" size="small" />
            </o-tooltip>
          </o-field>
        </div>

        <table class="table table-striped">
          <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th class="center-switch">Enabled</th>
            <th class="center-switch">List</th>
            <th class="center-switch">Show</th>
            <th class="center-switch">Create</th>
            <th class="center-switch">Update</th>
            <th class="center-switch">Delete</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in role.permissions" :key="n.key">
            <td>{{ n.name }}</td>
            <td class="td-description">{{ n.description }}</td>
            <td class="center-switch">
              <o-tooltip label="This type does not send email" type="is-info" :active="!n.hasMailNotification">
                <o-switch v-model="n.enabled"></o-switch>
              </o-tooltip>
            </td>
            <td class="center-switch">
              <o-tooltip v-if="!(n.only_main)" label="This type does not send notification" type="is-info" :active="n.isPage">
                <o-switch :disabled="!(n.enabled)" v-model="n.list"></o-switch>
              </o-tooltip>
            </td>
            <td class="center-switch">
              <o-tooltip v-if="!(n.only_main)" label="This type does not send notification" type="is-info" :active="n.isPage">
                <o-switch :disabled="!(n.enabled)" v-model="n.show"></o-switch>
              </o-tooltip>
            </td>
            <td class="center-switch">
              <o-tooltip v-if="!(n.only_main)" label="This type does not send notification" type="is-info" :active="n.isPage">
                <o-switch :disabled="!(n.enabled)" v-model="n.create"></o-switch>
              </o-tooltip>
            </td>
            <td class="center-switch">
              <o-tooltip v-if="!(n.only_main)" label="This type does not send notification" type="is-info" :active="n.isPage">
                <o-switch :disabled="!(n.enabled)" v-model="n.update"></o-switch>
              </o-tooltip>
            </td>
            <td class="center-switch">
              <o-tooltip v-if="!(n.only_main)" label="This type does not send notification" type="is-info" :active="n.isPage">
                <o-switch :disabled="!(n.enabled)" v-model="n.remove"></o-switch>
              </o-tooltip>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="control">
      <button v-submit="submitting" class="button is-success">Save</button>
      <!--          <button type="submit" class="button is-success">Save</button>-->
    </p>
  </form>
</template>
<script>
import HandlesForm from '../../mixins/HandlesForm'
import {mapGetters, mapActions} from 'vuex'
import {createOrUpdateRole} from "../../store/modules/roles/actions";

export default {
  mixins: [HandlesForm],
  components: {},
  props: {
    editMode: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      role: null,
      permissions: []
    }
  },
  mounted() {
    if (this.editMode) {
      this.fetchRoleById(this.$route.params.slug)
          .then(response => {

            // Adding any newly added role permissions
            let missingRoles = this.rolePermissions.filter(role=> !response.data.data.permissions.some(present=> present.key===role.key))
            response.data.data.permissions = response.data.data.permissions.concat(missingRoles)
            this.role = response.data.data
            return response
          })
    } else {
      this.role = {
        name: '',
        description: '',
        permissions: this.rolePermissions
      }
    }
    this.permissions = this.rolePermissions

  },
  methods: {

    ...mapActions(['createOrUpdateRole', 'fetchRoleById']),

    handleRole() {
      let submit = this.wrapSubmit(this.createOrUpdateRole)
      submit(this.role)
          .then(res => {
            this.successMessage('Role ' + (this.editMode ? 'updated' : 'created') + ' successfull')
            this.role.id ? this.$router.push(`/roles/`) : this.$router.push(`/roles/`)
            this.role.name = ''
            this.role.description = ''
            return res
          })

    }
  },
  computed: {
    ...mapGetters(['rolePermissions']),
  }
}
</script>

<style>
.role-form .table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.role-form .table tr:nth-child(odd) {
  background-color: #fff;
}

.role-form .table thead {
  border-bottom: 1px solid #f0f0f0
}

.role-form .table {
  border: none !important;
}

.role-form .table .center-switch {
  width: 179px;
  text-align: center !important;
}

.role-form tr.no-padding td {
  padding: 17px 9px;
  font-weight: bold;
  background-color: #e3e7ed;
  min-width: 165px;
}

.role-form td.td-description {
  width: 100%;
}

@media (min-width: 1380px) and (max-width: 1599px) {
  .role-form .table td {
    padding: 10px 9px;
  }
}

.role-form .switch[disabled] {
  opacity: 0.2;
}
</style>
